// Utility function to convert PascalCase to camelCase
const pascalToCamel = (str) => str.charAt(0).toLowerCase() + str.slice(1);

// Function to convert an object's keys from PascalCase to camelCase
const convertKeysToCamelCase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(convertKeysToCamelCase);
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const camelCaseKey = pascalToCamel(key);
      acc[camelCaseKey] = convertKeysToCamelCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
};

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
}

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

const calculateCenter = (coordinates) => {
  if (coordinates.length === 0) return null;

  let latSum = 0;
  let lngSum = 0;
  let totalPoints = 0;

  for (const key in coordinates) {
    if (coordinates.hasOwnProperty(key)) {
      const { lat, lng } = coordinates[key];
      latSum += lat;
      lngSum += lng;
      totalPoints++;
    }
  }

  if (totalPoints === 0) {
    return null; // Handle case where there are no points
  }

  return {
    lat: latSum / totalPoints,
    lng: lngSum / totalPoints,
  };
};

const extractAndCapitalizePOIsInitial = (str) => {
  // Use a regular expression to match any single-digit number followed by a dash, another single-digit, and then a space
  const match = str.match(/\d-\d\s(\w)/);

  if (match) {
    // match[1] contains the first letter after the digit-digit pattern
    return match[1].toUpperCase();
  }

  return ""; // Return an empty string if the pattern is not found
};

function formatDate(dateString) {
  const date = new Date(dateString);
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  return new Intl.DateTimeFormat("en-GB", options).format(date);
}

const animateMarkerMovement = (
  markerInstance,
  newLatLng,
  callback = () => {}
) => {
  const duration = 10000;
  const currentLatLng = markerInstance.position;
  console.log(newLatLng, markerInstance);
  const deltaLat = newLatLng.lat - currentLatLng.lat();
  const deltaLng = newLatLng.lng - currentLatLng.lng();

  const steps = duration / 16; // ~60fps
  let step = 0;

  const interval = setInterval(() => {
    if (step >= steps) {
      clearInterval(interval);
      markerInstance.setPosition(newLatLng); // Ensure it ends exactly at the target position
      callback();
      return;
    }

    const progress = step / steps;

    const lat = currentLatLng.lat() + deltaLat * progress;
    const lng = currentLatLng.lng() + deltaLng * progress;

    markerInstance.setPosition(new window.google.maps.LatLng(lat, lng));
    step++;
  }, 16); // ~60fps
};

function GetTeamNameAndIdentifier(input) {
  // Check if a slash exists in the string
  if (input.includes("/")) {
    // Split the string by slash
    const [teamName, identifier] = input.split("/").map((part) => part.trim());
    return { teamName, identifier };
  }

  // If no slash, return teamName as the whole value and identifier as an empty string
  return { teamName: input.trim(), identifier: "" };
}

function SpeedStatus(inputString, actualSpeed) {
  if (typeof inputString !== "string") {
    return "";
  }

  const parts = inputString.split(",");

  const speedRegex = /\d+-\d+\s+snelheid\s+(\d+)\s+km\/u/gi;

  let speedLimit = null;

  for (let part of parts) {
    const match = speedRegex.exec(part);
    if (match) {
      speedLimit = parseInt(match[1], 10);
      break;
    }
  }

  if (speedLimit === null) {
    return "";
  }

  const graceSpeedLimit = speedLimit * 1.1;

  if (actualSpeed > graceSpeedLimit + 30) {
    return "DisqualifyOverSpeed";
  } else if (actualSpeed > graceSpeedLimit) {
    return "OverSpeed";
  } else {
    return "";
  }
}

export {
  convertKeysToCamelCase,
  stringAvatar,
  stringToColor,
  calculateCenter,
  extractAndCapitalizePOIsInitial,
  formatDate,
  animateMarkerMovement,
  GetTeamNameAndIdentifier,
  SpeedStatus,
};
